import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import './portfolio.css';
import { library } from '@fortawesome/fontawesome-svg-core' 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

export default function Portfolio(props) {       
     return(
     <div className="container-fluid">
  <nav >
      <div className="d-flex justify-content-between md">

    <img src="/mlogo.png" alt="Mpho logo" title="Homepage" className="logo">
    </img>
    <ul>

      <li className="active"> <a href="/" title="Homepage">Home</a></li>
      <li> <Link to="/projects" title="Projects">Projects</Link></li>
      <li><a href="/resume.pdf" target="_blank" rel="noreferrer">Resume</a></li>
    </ul>
    </div>
  </nav>
 <h3 className="intro">Hi, I am</h3>
    <h1 className="name">MPHO</h1>
     <h2 className="secondname ">MABUSHE</h2>
  <div className="row d-flex">
    <div className="col-lg-3 col-md-2 d-none d-md-block">
  <ul class="social-links">
  <li><a href="mailto:wendyxmabushe@gmail.com" class="email-link" rel="noreferrer"><FontAwesomeIcon icon="fa-solid fa-message" /></a></li>
  <li><a href="www.linkedin.com/in/mphomabushe" target="_blank"  title="linkedin profile" rel="noreferrer"><FontAwesomeIcon icon="fa-brands fa-linkedin" /></a></li>
  <li><a href="https://github.com/MphoMabushe" target="_blank" title="github profile" rel="noreferrer"><FontAwesomeIcon icon="fa-brands fa-github" /></a></li>
  </ul>
</div>
<div className="col-lg-3 col-md-2 about-section">
  <h2 class="mt-4">
          Front-end developer,based in South Africa
      </h2>
  <p>I'm a beginner software developer. 
    I thrive on the challenge of bringing website ideas to life,
     enjoying the process of transforming code into functional, 
     usable experiences.
</p>
<button className="button"> <a href="/resume.pdf" target="_blank" rel="noreferrer">DOWNLOAD CV</a></button>
    </div>
    <div className="col-lg-3 col-md-2">
<img  src="/portfolioo.jpg" alt="mpho" title="Bio picture" className="portfolio-picture img-fluid p-3 mb-5"></img></div>
 <div className="contact-section d-inline-block d-md-none mt-5">
   <h1>
    Lets get intouch!
</h1>
 <ul class="social-linkssmall">
  <li><a href="mailto:wendyxmabushe@gmail.com" class="email-link" rel="noreferrer"><FontAwesomeIcon icon="fa-solid fa-message" /></a></li>
  <li><a href="www.linkedin.com/in/mphomabushe" target="_blank" title="linkedin profile" rel="noreferrer"><FontAwesomeIcon icon="fa-brands fa-linkedin" /></a></li>
  <li><a href="https://github.com/MphoMabushe" target="_blank" title="github profile" rel="noreferrer"><FontAwesomeIcon icon="fa-brands fa-github" /></a></li>
  </ul>
  </div>
</div>
 <footer>
  This project was coded by <a href="https://www.instagram.com/mphomabushe/">Mpho Mabushe</a>,is <a href="https://github.com/MphoMabushe">open-sourced on Github</a> and<a href="https://app.netlify.com/teams/mphomabushe/projects"> hosted on Netlify</a>
  </footer>
  </div>
     );
}